import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ThumbnailDisplay from "./ThumbnailDisplay"

const ImageThumbnailDisplay = (props) => {
  const [thumbnails, setThumbnails] = useState([]);
  const {locatorId, api_web_address, update_loc_loading, isLoading, getThumbnails, reqThumbnails} = props
  //console.log(locatorId)

  useEffect(() => {
    // Fetch thumbnails for the given locatorId
    //console.log(`${api_web_address}/get_all_images_by_id/${locatorId}`)
    getThumbnails(locatorId)
      
  }, [locatorId]);

  // Handle the remove action for a thumbnail
  const handleRemove = (thumbnailUrl) => {
    // Request to remove the image from the server
    axios.post(`${api_web_address}/remove_image`, { thumbnail: thumbnailUrl })
      .then(() => {
        // Remove the image from the list on success
        getThumbnails(locatorId) //update photos set
      })
      .catch(error => {
        console.error('Error removing the image:', error);
      });
  };

  if (reqThumbnails.images.lenght === 0) return <></>
  return (
    <div className="thumbnail-gallery">
 
      <ThumbnailDisplay
        thumbnails={reqThumbnails.images}
        handleRemoveImage={handleRemove}
        api_web_address={api_web_address}
        update_loc_loading={update_loc_loading}
        isLoading={isLoading}
        //{ thumbnails, handleRemoveImage }update_loc_loading, isLoading}
      />
    </div>
  );
};

export default ImageThumbnailDisplay;